import { makeVar, useReactiveVar } from '@apollo/client'

type CookieConsent = 'accepted' | 'rejected' | null

const STORAGE_KEY = 'cookieConsent'

const getStoredConsent = (): CookieConsent => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'accepted' || stored === 'rejected') return stored
  return null
}

export const cookieConsentVar = makeVar<CookieConsent>(getStoredConsent())

/** Non-reactive consent read, for analytics modules that run outside React. */
export const hasCookieConsent = (): boolean => cookieConsentVar() === 'accepted'

export const useCookieConsent = () => {
  const consent = useReactiveVar(cookieConsentVar)

  const acceptAll = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted')
    cookieConsentVar('accepted')
  }

  const rejectAll = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected')
    cookieConsentVar('rejected')
  }

  const resetConsent = () => {
    localStorage.removeItem(STORAGE_KEY)
    cookieConsentVar(null)
  }

  return { consent, acceptAll, rejectAll, resetConsent }
}
